import { useNavigate } from "react-router-dom";
import { createTempUser } from "../../../services/api";
import { useBaseUrlCreateFlow } from "../../../services/urlServices";

export default function useFormSubmit(origin_app, medstar_association_type) {
    const navigateTo = useNavigate();
    const baseUrl = useBaseUrlCreateFlow();

    return function (data) {
        navigateTo(".", { replace: true }); // remove the error param (if it exist) from url as a new request/submit is being made
        createTempUser(
            origin_app,
            medstar_association_type,
            data.firstName,
            data.lastName,
            data.email,
            data.sesame1,
            r => {
                navigateTo(`${baseUrl}/step3/entercode`, { state: { email: data.email } });
            },
            r => {
                const message = (r?.response?.data?.message);
                navigateTo(`${baseUrl}/step2/credentials?error=${message ? message : 'unknown'}`);
            }
        );
    };
}
